export default {
  nav: {
    main: 'メイン',
    ordersAndInvoices: '注文と請求書',
    drafts: '下書き',
    automation: '自動化',
    workspace: 'ワークスペース',
    templates: 'テンプレート',
    delivery: '配信',
    settings: '設定',
    shippingLabels: '配送ラベル',
    subscriptions: 'サブスクリプション',
    support: 'サポート',
    developer: '開発者',
    writeReview: 'レビューを書く',
    supportTicket: 'サポートチケット',
    welcomeTour: 'ウェルカムツアー',
    administratorConsole: '管理者コンソール',
    logout: 'ログアウト',
  },
  dashboard: {
    pageTitle: '注文と請求書',
    pageDescription: 'Manage your orders and invoices',
    title: '注文と請求書',
    selectedOrders: '{count} 件の注文を選択中',
    completed: '% 完了',
    processing: '処理中です。お待ちください...',
    bulkDownload: '一括ダウンロード',
    upgradeBulkDownload: '一括ダウンロードにはプランのアップグレードが必要です',
    showFilters: 'フィルターを表示',
    hideFilters: 'フィルターを非表示',
    creatingInvoices: '請求書を作成中です。お待ちください...',
    bulkCreateInvoices: '請求書を一括作成',
    cannotCreateAutopilot: '請求書発行モードが自動の場合、手動で請求書を作成することはできません。',
    exportInvoices: '請求書または注文をエクスポート',
    capturePayments: '手動で支払いをキャプチャ',
    filterOrders: '注文をフィルター',
    error: 'エラーが発生しました...',
    close: '閉じる',
    chooseDate: '日付を選択',
    chooseIssueDate: '選択した請求書の発行日を選択してください',
    cancel: 'キャンセル',
    createInvoices: '請求書を作成',
    storno: '取消',
    bulkOrderCapture: '注文の一括キャプチャ',
  },
  search: {
    createdBetween: '作成日範囲',
    modifiedBetween: '更新日範囲',
    orderNumber: '注文番号',
    invoiceNumber: '請求書番号',
    refundNumber: '返金番号',
    customer: '顧客',
    payment: '支払い',
    any: 'すべて',
    authorized: '承認済み',
    pending: '保留中',
    paid: '支払い済み',
    partiallyPaid: '一部支払い済み',
    refunded: '返金済み',
    voided: '無効',
    partiallyRefunded: '一部返金済み',
    unpaid: '未払い',
    fulfillment: 'フルフィルメント',
    fulfilled: '配送済み',
    partial: '一部配送',
    unfulfilled: '未配送',
    loading: '注文を読み込み中...',
    search: '検索',
  },
  orderList: {
    noCustomer: '顧客なし',
    downloadOrder: '注文をダウンロード',
    deleteWarning: '重要！この日付以降に作成されたすべての請求書と返金が削除されます：',
    includingInvoice: '選択した請求書番号を含む #',
    pressOk: '続行するにはOKを、中止するにはキャンセルを押してください。',
    cannotCreateAutopilot: '請求書発行モードが自動の場合、手動で請求書を作成することはできません。',
    createInvoice: 'この注文の請求書を作成',
    create: '作成',
    addCreditNote: 'クレジットノートを追加',
    createStorno: '取消請求書を作成',
    refund: '返金',
    downloadInvoice: 'この請求書をダウンロード',
    download: 'ダウンロード',
    default: 'デフォルト',
    downloadStorno: 'この取消/クレジットノートをダウンロード',
    fulfillOrder: '注文をフルフィル',
    orderNum: '注文番号',
    locPrefix: 'ロケーションプレフィックス',
    invoiceNum: '請求書番号',
    refundNum: '返金番号',
    customerCol: '顧客',
    orderCreatedDate: '注文作成日',
    orderModifiedDate: '注文更新日',
    delivered: '配送済み',
    paymentStatus: '支払いステータス',
    fulfillmentStatus: '配送状況',
    totalOutstanding: '未払い合計金額',
    originalPrice: '元の価格',
    noOrders: '選択したステータスの注文はありません。',
    cannotCreateNoOrders: '注文がない場合、請求書を作成できません。',
    createOrdersFirst: '少なくとも1件の注文を作成してから再試行してください。',
    createOrders: '注文を作成',
    loadingOrders: '読み込み中...',
    paidManual: '支払い済み - 手動',
    paid: '支払い済み',
    refunded: '返金済み',
    pending: '保留中',
    partiallyPaid: '一部支払い済み',
    partiallyRefunded: '一部返金済み',
    fulfilled: '配送済み',
    unfulfilled: '未配送',
    deliveryPending: '保留中',
    deliverNow: '今すぐ配信',
    deliveryPartial: '一部配信',
    notDelivered: '未配信',
    deliverAgain: '再配信',
    deliveryDetails: '配信詳細',
    deliveryFailed: '配信失敗',
    sent: '送信済み',
    failed: '失敗',
    toLabel: '宛先',
    folderLabel: 'フォルダ',
    open: '開く',
    invoice: '請求書',
    creditNote: 'クレジットノート',
    stornoLabel: '取消',
    unknown: '不明',
    googleDrive: 'Google Drive',
    clientsTablet: 'クライアントタブレット',
    shippyPro: 'ShippyPro',
    emailChannel: 'メール',
    ftpChannel: 'FTP',
    revertToDate: 'この日付に戻す',
    add: '追加',
    close: '閉じる',
  },
  downloadDialog: {
    downloadType: '{type}をダウンロード...',
    selectTemplate: 'ギャラリーからテンプレートを選択して、注文、請求書、取消請求書、またはクレジットノートをエクスポートします。',
    getMoreTemplates: 'その他のテンプレートを取得',
    createNewTemplate: '新しいテンプレートを作成',
    allCreatedBetween: '期間内に作成されたすべての{type}',
    selectedType: '選択した{type}',
    and: 'と',
    status: 'ステータス',
    any: 'すべて',
    open: 'オープン',
    closed: 'クローズ',
    cancelled: 'キャンセル済み',
    paymentStatus: '支払いステータス',
    fulfillmentStatus: '配送状況',
    fulfilled: '配送済み',
    partial: '一部配送',
    unfulfilled: '未配送',
    authorized: '承認済み',
    pending: '保留中',
    paid: '支払い済み',
    partiallyPaid: '一部支払い済み',
    refunded: '返金済み',
    voided: '無効',
    partiallyRefunded: '一部返金済み',
    unpaid: '未払い',
    format: 'フォーマット',
    forLocation: 'ロケーション',
    advancedOptions: '詳細オプション',
    exportHSCodes: '在庫HSコードをエクスポート（低速）',
    noteChrome: '注意: 最適なダウンロードにはChromeブラウザを推奨し、広告ブロッカーを無効にしてください。',
    downloadIndividually: '個別ダウンロード',
    downloadGrouped: '一括ダウンロード',
  },
  templates: {
    pageTitle: 'テンプレート',
    pageDescription: 'Customize your invoice templates',
    title: 'テンプレート',
    installTranslated: '翻訳済みテンプレートをインストール',
    installTranslatedDesc: 'このボタンをクリックして別の言語を選択してください。',
    createNew: '必要に応じて新しいテンプレートを作成',
    createNewDesc: '必要に応じてこのボタンをクリックして新しいテンプレートを作成してください。',
    customize: 'テンプレートをカスタマイズ',
    customizeDesc: 'デフォルトテンプレートをクリックしてカスタマイズできます。ロゴや色を変更でき、上級者はコードも編集できます。',
    defaultTemplate: '請求書、取消、クレジットノート（デフォルト）',
    logo: 'ロゴ',
    colorPalette: 'カラーパレット',
    getColorPalettes: 'カラーパレットを取得',
    paperSize: '用紙サイズ',
    format: 'フォーマット',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: '印刷方向',
    landscape: '横向き',
    portrait: '縦向き',
    margin: '余白 (cm)',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    save: '保存',
  },
  labels: {
    pageTitle: '配送ラベル',
    pageDescription: 'Create and manage shipping labels',
    title: '配送ラベル',
    glsRequiresPro: 'EEU向けGLS配送ラベルにはプロフェッショナルプランが必要です。',
    upgradeDesc: 'プロフェッショナルにアップグレードして配送ラベルを作成・管理しましょう。',
    upgradePlan: 'プランをアップグレード',
    eeuGls: 'EEU GLS',
    enabled: '有効',
    country: '国',
    hungary: 'ハンガリー',
    slovakia: 'スロバキア',
    czech: 'チェコ',
    romania: 'ルーマニア',
    slovenia: 'スロベニア',
    croatia: 'クロアチア',
    senderId: '送信者ID',
    username: 'ユーザー名',
    password: 'パスワード',
    name: '名前',
    city: '市区町村',
    address: '住所',
    zipCode: '郵便番号',
    contactPerson: '連絡先担当者',
    phone: '電話番号',
    email: 'メールアドレス',
    glsServices: 'GLSサービス',
    expressService: 'エクスプレスサービス',
    exchangeService: '交換サービス',
    smsService: 'SMSサービス',
    smsText: 'SMSテキスト',
    preAdviceService: '事前通知サービス',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    save: '保存',
  },
  billing: {
    pageTitle: '請求',
    pageDescription: 'Manage your subscription and billing',
    title: '請求',
    subscriptionFor: 'ショップのサブスクリプションプラン',
    currentlySubscribed: '現在のサブスクリプション：',
    plan: 'プラン',
    cancelSubscription: 'サブスクリプションをキャンセル',
    upgradePlan: 'プランをアップグレード',
    professional: 'プロフェッショナル',
    proPriceMonthly: '$29.99 / 月',
    upgrade: 'アップグレード',
    includesAllStarter: 'スターターの全機能に加えて：',
    proFeature1: 'グローバルコンプライアンススイート：ロケーションベースのプレフィックスとカスタム連番',
    proFeature2: 'スマートローカリゼーション：自動翻訳メールとローカライズされたPDF添付',
    proFeature3: '完全なB2Bドキュメントライフサイクル：見積書、B2B見積り、クレジットノート',
    proFeature4: 'B2B会計同期：小数点以下3桁の精度と複数通貨表示',
    proFeature5: '自動バックアップ：請求書をFTPまたはGoogle Driveに自動コピー',
    proFeature6: 'Shopify Flow：Flowトリガーとアクションによる請求書の生成、配信、取消の自動化',
    proFeature7: '高度なAIロジック：オンデバイスAIを使用した複雑な条件付きレイアウト句',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-Xエクスポート（欧州電子請求書コンプライアンス）',
    proFeature9: 'EPC QRコードによるモバイルPOS即時決済',
    proFeature10: 'EEU向けGLS配送ラベル',
    proFeature11: '7年間のコンプライアンス税務保管',
    currentlyUsing: '現在ご利用中のプラン：',
    free: '無料',
    subscriptionPlan: 'サブスクリプションプラン',
    monthlyUsage: '月間使用量',
    monthlyGenerated: '今月 {count} / 50 件の請求書',
    monthlyLimitReached: '月間上限に達しました。無制限の請求書にはスタータープランにアップグレードしてください。',
    freePlan: '無料プラン',
    freeToInstall: 'インストール無料',
    freeFeature1: '月間最大50件の請求書/注文',
    freeFeature2: '31種類以上の定義済みテンプレートにアクセス',
    freeFeature3: '基本AIコパイロット',
    freeFeature4: '標準PDFダウンロードと印刷',
    freeFeature5: '標準ドキュメントスイート（請求書、納品書、領収書）',
    freeFeature6: '3ヶ月間の安全な請求書保管',
    starterPlan: 'スタータープラン',
    starterPrice: '$9.99 / 月',
    starterPricePerInvoice: '+ 請求書1件あたり3¢',
    subscribe: '登録する',
    starterFeature1: '無制限の請求書と注文',
    starterFeature2: 'メールによる自動PDF配信',
    starterFeature3: 'ハイブリッドエディターとAIコパイロットへのフルアクセス',
    starterFeature4: 'Shopify POSとバーコード統合',
    starterFeature5: 'Shopify Flow：請求書自動化のためのトリガーとアクション',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-Xエクスポート（電子請求書コンプライアンス）',
    starterFeature7: '1年間の安全な請求書保管',
    proTaxOverrides: 'カスタム税率オーバーライド：商品別VAT/GSTおよびSKUレベルの税率',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    save: '保存',
  },
  autopilot: {
    pageTitle: '自動化',
    pageDescription: 'Automate invoice creation and management',
    title: '自動化',
    autoCreate: '請求書を自動作成',
    disabled: '無効（手動）',
    whenCreated: '注文作成時',
    whenFulfilled: '注文フルフィルメント時',
    whenPaid: '注文支払い時',
    autoCreateDesc: '請求書は注文の作成日、フルフィルメント日、または支払い日に作成されます。',
    autoStorno: '請求書を自動取消',
    whenCancelled: '注文がキャンセルまたは返金された時',
    autoStornoDesc: '取消請求書は、注文が無効化/キャンセルされた日、または返金が作成された日に作成されます。',
    cannotAutoFree: '無料プランでは請求書の自動作成はできません。',
    upgradePlan: 'プランをアップグレード',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    save: '保存',
  },
  delivery: {
    pageTitle: '配信',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: '配信',
    settings: '設定',
    useOrderNumbers: 'ファイルに注文番号を使用',
    sendIfCountry: '請求先住所の国が次の場合に送信',
    countryCodesHint: 'すべての国コードをセミコロンで区切って入力してください。',
    sendForTags: '以下のタグを持つ顧客に送信',
    tagsHint: 'すべてのタグをセミコロンで区切って入力してください。',
    emailDelivery: 'メール配信',
    sendAsPdf: '顧客にPDF添付ファイルとして請求書を送信',
    autoSend: '請求書作成時に自動送信',
    subject: '件名',
    body: '本文',
    xmlAttachments: 'XML添付ファイル',
    attachUbl: 'UBL/PEPPOL XML（E-Factura）を添付',
    attachZugferd: 'ZUGFeRD / Factur-X XMLを添付',
    sendTestEmail: 'テストメールを送信',
    sending: '送信中...',
    customSmtp: 'カスタムSMTPサーバー',
    customSmtpDesc: 'デフォルトの代わりに独自のメールサーバーを使用',
    enableSmtp: 'カスタムSMTPを有効にする',
    smtpHost: 'SMTPホスト',
    port: 'ポート',
    useSsl: 'SSL/TLSを使用',
    username: 'ユーザー名',
    password: 'パスワード',
    fromEmail: '送信元メールアドレス',
    fromName: '送信者名',
    shopifyLiquid: 'Shopify Liquidテンプレート',
    pasteInto: 'これをあなたの',
    orderConfirmation: '注文確認テンプレート',
    toAddLink: 'に貼り付けてダウンロードリンクを追加します。',
    downloadInvoice: '請求書をダウンロード',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: '請求書作成時にClientsTabletにリクエストを送信',
    shippyPro: 'ShippyPro',
    shippyProDesc: '非EU国向けにPDF請求書を税関書類としてShippyProに送信',
    ftpBackup: 'FTP / SFTPバックアップ',
    ftpDesc: '請求書をサーバーに自動コピー',
    enableFtp: '自動FTPバックアップを有効にする',
    host: 'ホスト',
    useSftp: 'SFTP（セキュア）を使用',
    destinationFolder: '保存先フォルダ',
    xmlFiles: 'XMLファイル',
    includeUbl: 'UBL/PEPPOL XML（E-Factura）を含める',
    includeZugferd: 'ZUGFeRD / Factur-X XMLを含める',
    testConnection: '接続テスト',
    testing: 'テスト中...',
    pro: 'PRO',
    upgradeFtp: 'プロフェッショナルにアップグレードしてFTP/SFTPサーバーへの自動コピーを有効にしましょう。',
    googleDrive: 'Google Drive',
    googleDriveDesc: '請求書をDriveに自動同期',
    connected: '接続済み',
    disconnect: '切断',
    notWorking: '動作しない場合は',
    googlePermissions: 'Googleの権限',
    removeThenReconnect: 'からInvoice Browseを削除し、再接続してください。',
    connectGoogleDrive: 'Google Driveに接続',
    upgradeGoogleDrive: 'プロフェッショナルにアップグレードしてGoogle Driveへの自動同期を有効にしましょう。',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: '保存',
  },
  bookkeeping: {
    pageTitle: '設定',
    pageDescription: 'Configure your invoice settings',
    title: '設定',
    owner: '所有者',
    email: 'メール',
    phone: '電話番号',
    keepDifferentNumbering: '注文ロケーションごとに異なる請求書番号を維持',
    keepDifferentNumberingDisabled: 'お使いのプランでは、注文ロケーションごとの異なる請求書番号設定は有効になっていません。',
    locationEmailDesc: '注文ロケーション（在庫ロケーション、配送先住所、請求先住所）に基づいて翻訳されたメールと請求書を送信できます',
    upgradePlan: 'プランをアップグレード',
    matchingCriteria: 'マッチング条件',
    locationId: 'ロケーションID',
    shippingCountryCode: '配送先住所の国コード',
    billingCountryCode: '請求先住所の国コード',
    matchLocationDesc: '注文ロケーションID、配送先または請求先住所の国コードに基づいてロケーションをマッチングします。',
    companyInfo: '会社情報',
    name: '名前',
    website: 'ウェブサイト',
    registrationNumber: '登録番号',
    taxId: '税番号',
    addressSection: '住所',
    streetName: '町名',
    streetNumber: '番地',
    zip: '郵便番号',
    city: '市区町村',
    region: '都道府県',
    country: '国',
    bankingInfo: '銀行情報',
    bankName: '銀行名',
    swift: 'Swift',
    currency: '通貨',
    iban: 'IBAN',
    invoicing: '請求書発行',
    decimalPlaces: '小数点以下桁数',
    invoicesPrefix: '請求書プレフィックス',
    currentInvoiceNumber: '現在の請求書番号',
    creditNotesPrefix: 'クレジットノートプレフィックス',
    currentCreditNoteNumber: '現在のクレジットノート番号',
    lastInvoiceDate: '最終請求書日付',
    noInvoicesYet: 'まだ請求書は作成されていません。',
    confirmReverting: 'システム復元の確認',
    allInvoicesAfter: '以下の日付以降に発行されたすべての請求書とその取消：',
    willBeRemoved: 'が削除されます。システムの復元を続行しますか？',
    cancel: 'キャンセル',
    revert: '復元',
    revertDesc: 'システムの復元により、選択した日付以降に作成されたすべての請求書が消去されます。',
    revertToDate: 'この日付に復元',
    reverting: 'システムを復元中です。お待ちください...',
    useOrderNumbering: '注文番号を使用',
    showVat: '請求書にVATを表示',
    overrideTaxes: '税率をオーバーライド',
    pricesIncludeTax: '価格は税込み',
    productsTaxRate: '商品税率',
    shippingTaxRate: '配送税率',
    skusSeparated: 'SKUをセミコロンで区切る',
    skusTaxRate: 'SKU税率',
    useOrderDates: '請求書に注文作成日を使用',
    convertCurrency: '顧客が支払う通貨に価格を変換',
    unsavedChanges: '未保存の変更',
    discard: '破棄',
    save: '保存',
  },
  drafts: {
    pageTitle: '下書き',
    pageDescription: 'Manage your draft orders',
    title: '下書き',
    download: 'ダウンロード',
    newDraft: '新規下書き',
    exporting: 'エクスポート中 {status}%...',
    accessNotGranted: '下書き注文へのアクセスが許可されていません。',
    reLogin: '再ログイン',
    toGrantPermissions: 'して「下書き注文」の権限を付与してください。',
    pushFailed: 'Shopifyへのプッシュに失敗しました：',
    exportError: 'エクスポートエラー：',
    confirmDelete: 'この下書きを削除してもよろしいですか？',
    incompleteCustomer: '顧客データが不完全です：',
    pushWithoutCustomer: '下書きは顧客データなしでShopifyにプッシュされます。続行しますか？',
    customerNotInShopify: 'この顧客はまだShopifyに存在しません。',
    warnings: '警告：',
    createCustomerAndPush: 'Shopifyに顧客を作成して下書き注文をプッシュしますか？',
    downloadTitle: '下書きをダウンロード',
    cancel: 'キャンセル',
  },
  draftEdit: {
    number: "番号",
    prefix: "プレフィックス",

    newDraft: '新規下書き',
    editDraft: '下書きを編集',
    viewInShopify: 'Shopifyで表示',
    back: '戻る',
    createDraft: '下書きを作成',
    saveChanges: '変更を保存',
    documentType: 'ドキュメントタイプ',
    draftOrder: '下書き注文',
    quote: '見積書',
    proforma: 'プロフォーマ',
    manualInvoice: '手動請求書',
    currency: '通貨',
    expiryDate: '有効期限',
    status: 'ステータス',
    draft: '下書き',
    sent: '送信済み',
    accepted: '承認済み',
    customer: '顧客',
    firstName: '名',
    lastName: '姓',
    email: 'メールアドレス',
    phone: '電話番号',
    company: '会社名',
    taxId: '税番号',
    billingAddress: '請求先住所',
    address: '住所',
    aptSuite: '部屋番号',
    city: '市区町村',
    province: '都道府県',
    countryField: '国',
    zip: '郵便番号',
    shippingAddress: '配送先住所',
    sameAsBilling: '請求先と同じ',
    lineItems: '明細項目',
    shipping: '配送',
    shippingTitle: 'タイトル',
    shippingPlaceholder: '例：標準配送',
    price: '価格',
    note: '備考',
    notePlaceholder: '内部メモまたは顧客へのメッセージ...',
    summary: '概要',
    subtotal: '小計',
    discounts: '割引',
    tax: '税',
    total: '合計',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'ショップアドレスを入力',
    loginWith: 'ログイン：',
    createAccount: '新しいアカウントを作成',
    placeholder: 'your-shop-name',
    shopRequired: 'ショップ名は必須です',
    login: 'ログイン',
    shopify: 'Shopify',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Invoice Browseをお楽しみいただけていますか？',
    description: '最初の請求書が作成されました！アプリが便利だと感じていただけたら、Shopifyアプリストアでのレビューが私たちの大きな助けになります。',
    reward: 'お礼として、月間使用量カウンターを0にリセットいたします',
    leaveReview: 'レビューを書く',
    maybeLater: 'また後で',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Invoice Browseへようこそ',
    welcomeContent: '使い方をご紹介します。',
    dashboardTitle: 'ダッシュボード',
    dashboardContent: 'この画面はメインダッシュボードです。ここではすべての注文を確認でき、請求書、納品書などのさまざまなドキュメントタイプにエクスポートできます。',
    automationTitle: '作業を楽にしましょう',
    automationContent: '自動化を有効にして、注文の支払いや返金時に請求書を自動作成します。',
    templatesTitle: 'テンプレートをカスタマイズ',
    templatesContent: 'ここからテンプレートの翻訳、カスタマイズ、または新規作成ができます。',
    deliveryTitle: '配信',
    deliveryContent: '作成したドキュメントをFTP、Google Drive、またはメールの添付ファイルとして自動コピーするように設定できます。',
    settingsTitle: '設定',
    settingsContent1: 'ドキュメントに使用される会社の電話番号、メール、その他のフィールドを調整します。',
    settingsContent2: 'ドキュメントの開始番号を変更したり、指定日以降のドキュメントを消去できます。',
    settingsContent3: '配送と商品のVAT税率をオーバーライドできます',
    settingsContent4: '数値の小数点以下桁数を変更できます',
    reviewTitle: 'レビューを書く',
    reviewContent: 'レビューを書いて私たちのチームをサポートしてください！',
    tourTitle: 'ウェルカムツアー',
    tourContent: 'ここからいつでもこのツアーを再度開くことができます。',
    createDocTitle: '最初のドキュメントを作成',
    createDocContent: '作成ボタンをクリックして最初のドキュメントを作成しましょう。',
    docNumberTitle: 'ドキュメント番号',
    docNumberContent: '最初のドキュメントには番号1が割り当てられます。別の番号から開始したい場合は、設定から変更できます。',
    downloadDocTitle: 'ドキュメントをダウンロード',
    downloadDocContent: 'ダウンロードのドロップダウンをクリックし、ドキュメントテンプレートを選択して注文をPDFとしてエクスポートします。',
  },
  common: {
    save: '保存',
    cancel: 'キャンセル',
    close: '閉じる',
    discard: '破棄',
    delete: '削除',
    edit: '編集',
    create: '作成',
    loading: '読み込み中...',
    unsavedChanges: '未保存の変更',
    upgradePlan: 'プランをアップグレード',
  },
  languageSelector: {
    label: '言語',
    auto: '自動検出',
  },
  draftList: {
    draftNum: '下書き #',
    shopifyId: 'Shopify ID',
    type: '種類',
    customer: '顧客',
    total: '合計',
    status: 'ステータス',
    delivered: '配信済み',
    date: '日付',
    actions: '操作',
    noCustomer: '顧客なし',
    noDrafts: '下書きまたは見積書が見つかりません。',
    loading: '読み込み中...',
    download: 'ダウンロード',
    default: 'デフォルト',
    pending: '保留中',
    deliverNow: '今すぐ配信',
    deliveryDetails: '配信詳細',
    sent: '送信済み',
    failed: '失敗',
    deliverAgain: '再配信',
    partial: '一部',
    notDelivered: '未配信',
    deliveryFailed: '配信失敗',
    unknown: '不明',
    edit: '編集',
    send: '送信',
    pushToShopify: 'Shopifyに送信',
    complete: '完了',
    duplicate: '複製',
    delete: '削除',
    quote: '見積書',
    proforma: 'プロフォーマ',
    draftOrder: '下書き注文',
    manualInvoice: '手動請求書',
  },
  draftSearch: {
    createdBtw: '作成日',
    draftNum: '下書き #',
    shopifyId: 'Shopify ID',
    customer: '顧客',
    status: 'ステータス',
    type: '種類',
    delivery: '配信',
    any: 'すべて',
    draft: '下書き',
    sent: '送信済み',
    accepted: '承認済み',
    expired: '期限切れ',
    converted: '変換済み',
    cancelled: 'キャンセル',
    quote: '見積書',
    proforma: 'プロフォーマ',
    draftOrder: '下書き注文',
    manualInvoice: '手動請求書',
    delivered: '配信済み',
    notDelivered: '未配信',
    pending: '保留中',
    search: '検索',
  },
  draftDownload: {
    title: '下書きと見積書のダウンロード...',
    selectTemplate: 'ギャラリーからテンプレートを選択して、下書き、見積書、またはプロフォーマをエクスポートします。',
    allDraftsBetween: '期間内のすべての下書き',
    selectedDrafts: '選択した下書き',
    and: 'と',
    status: 'ステータス',
    documentType: 'ドキュメントの種類',
    any: 'すべて',
    draft: '下書き',
    sent: '送信済み',
    accepted: '承認済み',
    expired: '期限切れ',
    converted: '変換済み',
    cancelled: 'キャンセル',
    quote: '見積書',
    proforma: 'プロフォーマ',
    draftOrder: '下書き注文',
    manualInvoice: '手動請求書',
    format: 'フォーマット',
    noTemplates: 'テンプレートが見つかりません',
    noTemplatesForType: 'ドキュメントの種類「{type}」のテンプレートが見つかりません。',
    installTemplates: 'テンプレートをインストール',
    toStartExporting: 'してエクスポートを開始します。',
    noteChrome: '注意: 最適なダウンロードにはChromeブラウザの使用と広告ブロッカーの無効化を推奨します。',
    cancel: 'キャンセル',
    downloadIndividually: '個別ダウンロード',
    downloadGrouped: 'まとめてダウンロード',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: '新しいテンプレートをインストール',
    tabStyle: 'スタイル',
    tabContent: 'コンテンツ',
    tabTranslations: '翻訳',
    tabSettings: '設定',
    tabCode: 'コード',
    tabCopilot: 'AIコパイロット',
    logo: 'ロゴ',
    colorPalette: 'カラーパレット',
    colorText: 'テキスト',
    colorBg: '背景',
    colorBorder: 'ボーダー',
    colorPrimary: 'プライマリ',
    colorAccent: 'アクセント',
    font: 'フォント',
    fontDefault: 'デフォルト (DM Sans)',
    fontSize: 'フォントサイズ',
    fontSizeDefault: 'デフォルト (11.5px)',
    fontSizeCompact: 'コンパクト',
    fontSizeSmall: '小',
    fontSizeMediumSmall: 'やや小',
    fontSizeMedium: '中',
    fontSizeMediumLarge: 'やや大',
    fontSizeLarge: '大',
    fontSizeExtraLarge: '特大',
    documentTitle: 'ドキュメントタイトル',
    documentTitlePlaceholder: '例: 請求書、税務請求書、ファクトゥーラ...',
    noToggleSupport: 'このテンプレートはトグルコントロールに対応していません。完全なカスタマイズにはギャラリーテンプレートに切り替えてください。',
    sections: 'セクション',
    shippingAddress: '配送先住所',
    bankPaymentDetails: '銀行/支払い情報',
    paymentStatusBadge: '支払いステータスバッジ',
    orderNotes: '注文メモ',
    trackingFulfillment: '追跡/フルフィルメント情報',
    termsConditions: '利用規約',
    signatureLines: '署名欄',
    qrCode: 'QRコード',
    lineItems: '明細項目',
    taxColumns: '税金列 (VAT / GST)',
    productSku: '商品SKU',
    productImages: '商品画像',
    discountBreakdown: '割引内訳',
    itemWeight: '商品重量',
    hsCode: 'HSコード（税関）',
    mergeDiscounts: '割引を商品価格に統合',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: '合計',
    subtotalBeforeTax: '小計（税抜）',
    taxBreakdownByRate: '税率別内訳',
    shippingCostSeparate: '送料を別行で表示',
    dueDate: '支払期日',
    formatting: 'フォーマット',
    dateFormat: '日付形式',
    decimalPlaces: '小数点以下桁数',
    paymentTerms: '支払条件',
    paymentTermsNone: 'なし',
    thankYouMessage: 'お礼メッセージ',
    thankYouPlaceholder: 'ご利用ありがとうございます！',
    countryMatchTitle: '配送先または請求先の国が一致する場合にこのテンプレートを使用',
    addressType: '住所の種類',
    addressDisabled: '無効',
    addressShipping: '配送先住所',
    addressBilling: '請求先住所',
    country: '国',
    anyCountry: 'すべての国',
    countryMatchDesc: '有効にすると、選択した住所が指定した国と一致する注文に対して、このテンプレートが自動的に使用されます。',
    languagePreset: '言語プリセット',
    selectLanguage: '言語を選択...',
    languagePresetDesc: '言語を選択すると、以下のすべてのラベルが入力されます。その後、個別のフィールドをカスタマイズできます。',
    paperSize: '用紙サイズ',
    format: 'フォーマット',
    orientation: '向き',
    portrait: '縦向き',
    landscape: '横向き',
    margin: '余白 (cm)',
    template: 'テンプレート',
    templateName: '名前',
    systemAlias: 'システムエイリアス',
    systemAliasDesc: 'POS/管理URLルート用',
    systemAliasNone: 'なし',
    defaultTemplate: 'デフォルトテンプレート',
    defaultTemplateDesc: '顧客と共有する直接リンクに使用されます。',
    posRouteDesc: 'POS連携用の /template/[alias]/receipt.pdf にマッピングされます。',
    documentType: 'ドキュメントの種類',
    invoiceCreditNote: '請求書 + クレジットノート',
    order: '注文',
    invoiceOnly: '請求書のみ',
    quoteEstimate: '見積書',
    proformaInvoice: 'プロフォーマ請求書',
    refund: '返金',
    stornoInvoice: 'ストルノ請求書',
    creditNoteOnly: 'クレジットノートのみ',
    reportLiquid: 'レポート（Liquidのみ）',
    hideRemovedItems: '削除/返金済み明細を非表示',
    location: 'ロケーション',
    locationEmpty: 'すべてのロケーションで使用する場合は空のままにしてください',
    dangerZone: '危険ゾーン',
    dangerZoneDesc: 'このテンプレートをアカウントから完全に削除します。',
    removeTemplate: 'テンプレートを削除',
    bodyTemplate: 'ボディテンプレート',
    bodyTemplateDesc: 'MustacheまたはLiquid構文を使用。スニペットをクリック:',
    rowTemplate: '行テンプレート',
    rowTemplateDesc: '明細項目ごとに1回レンダリングされます。スニペットをクリック:',
    variableReference: '変数リファレンス',
    formatCode: 'コード整形',
    insert: '挿入',
    copy: 'コピー',
    loadModelContinue: 'モデルを読み込んで続行',
    cancel: 'キャンセル',
    copilotPlaceholder: '例: ルーマニア語に翻訳、税金列を表示、バーコードを追加、ティールパレットを使用...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: '元に戻す',
    redo: 'やり直し',
    aiThinking: 'AIが考えています...',
    proposedChanges: '提案された変更',
    applyChanges: '変更を適用',
    dismiss: '却下',
    aiEngineReady: 'AIエンジン準備完了',
    loadingAiModel: 'AIモデルを読み込み中...',
    aiEngineOff: 'AIエンジンオフ —',
    loadForAdvanced: '高度な編集用に読み込む',
    instantCommands: '翻訳、セクションの表示/非表示、スニペットの追加、フォント/色/用紙の変更',
    aiEngineDesc: '構造的なHTML編集、レイアウト変更、カスタム修正',
    aiLocalDesc: 'モデルはWebGPU経由でローカルで実行されます — データはブラウザ外に送信されません。大きなモデルはより正確ですが、より多くのVRAMを使用します。',
    aiUpgradeDesc: '高度なAIテンプレート編集を有効にするにはStarterまたはProfessionalにアップグレードしてください。',
    upgrade: 'アップグレード',
    loadAiQuestion: 'AIエンジンを読み込みますか？',
    loadAiDesc: 'オンデバイスAIモデルがダウンロードされ、WebGPUを使用してローカルで実行されます。約1-3 GBの空きVRAM/RAMと最新のGPU（M1+ Mac、またはWindows/Linuxの専用GPU）が必要です。',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/ja.js